import { Component, OnInit } from "@angular/core";


@Component({
  selector: "app-unauthorized",
  templateUrl: '../templates/template1/views/app-unauthorized.component.html',
  styleUrls: ["../templates/template1/themes/default/CSS/app-header.less"]
 
})
export class AppUnauthorizedComponent implements OnInit {

  ngOnInit() {
 
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/app-unauthorized.component.ts